import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { HttpErrorHandler, HandleError } from '../../http-error-handler.service';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { EndpointLocationProviderService } from './endpoint-location-provider.service';

@Injectable()
export class IbgeService {

    private env = environment;
    private handleError: HandleError;
    private devURI = 'https://d-acsafeweb.safewebpss.com.br/Service/Microservice/Shared/Ibge';

    constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler, private endpointLocationService: EndpointLocationProviderService) {
        this.handleError = httpErrorHandler.createHandleError('IbgeService');
    }

    getListEstados() {
        return this.http
            .get(`${this.endpointLocationService.isLocalHost() ? this.devURI : (this.endpointLocationService.getWindowURL() + this.env.API_ENDPOINT_IBGE.link)}/api/uf/getlist`)
            .pipe(
                catchError(this.handleError('Buscar a lista de UFs', []))
            );
    }

    getListEstadosByPais(CodigoAlpha3) {
        return this.http
            .get(`${this.endpointLocationService.isLocalHost() ? this.devURI : (this.endpointLocationService.getWindowURL() + this.env.API_ENDPOINT_IBGE.link)}/api/uf/GetListByCodigoAlpha3/${CodigoAlpha3}`)
            .pipe(
                catchError(this.handleError('Buscar a lista de UFs pelo Código Alpha 3', []))
            );
    }

    getListPaises(): Observable<any> {
        return this.http
            .get(`${this.endpointLocationService.isLocalHost() ? this.devURI : (this.endpointLocationService.getWindowURL() + this.env.API_ENDPOINT_IBGE.link)}/api/pais/getlist`)
            .pipe(
                catchError(this.handleError('Buscar a lista de Paises', []))
            );
    }

    getListMunicipios(CodigoIBGE: any) {
        return this.http
            .get(`${this.endpointLocationService.isLocalHost() ? this.devURI : (this.endpointLocationService.getWindowURL() + this.env.API_ENDPOINT_IBGE.link)}/api/Municipio/GetListByCodigoIBGE/${CodigoIBGE}`)
            .pipe(
                catchError(this.handleError('Buscar a lista de Municípios', []))
            );
    }
}
